import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { G2Error } from '@Core/services/proprietary/error.service';

@Component({
    standalone: false,
    selector: 'error-dialog',
    templateUrl: './error-dialog.component.html'
})
export class ErrorDialogComponent {
    @Input() error: G2Error;

    @Input() errors: G2Error[];

    constructor(public activeModal: NgbActiveModal) { }

    async copyToClipboard(error: G2Error) {
        if (!navigator.clipboard) {
            return;
        }

        try {
            let clipboardText = error.errorsToCopy;
            await navigator.clipboard.writeText(clipboardText);
        } catch (err) {
            console.error('Failed to copy!', err);
        }
    }

    close() {
        this.activeModal.close();
    }
}
